module.exports = __webpack_public_path__ + "img/doors_close.8d09cb97.svg";